import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
/* IMPORT HERE */

const environments: ThemeUICSSObject = {
  // gap: spacing(6),
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'start',
  '.addEnvBtn span': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '.searchEnvironmentContainerBackground': {
    height: 'auto',
    backgroundColor: 'palette.background.paper',
    width: '100%',
  },
  '.searchEnvironmentContainer': {
    display: 'flex',
    justifyContent: 'space-between',
    flexdirection: ' initial',
    width: '100%',
    gap: 5,
    position: 'sticky',
    top: '0px',
    zIndex: 850,
    borderBottom: '1px solid',
    borderColor: 'palette.border.article',
    py: 3,
    background: 'palette.background.paper',
  },
  '& .searchEnvironments': {
    width: responsive({ 0: 'auto', 3: '300px' }),
    borderColor: 'palette.border.section',
  },
  '.environmentList': {
    display: 'flex',
    width: '100%',
    pt: 6,
    flexDirection: 'column',
    gap: spacing(3),
  },

  '.profile__environments': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(6),
    p: spacing(6),
    width: '100%',
    border: '1px solid',
    borderColor: 'palette.border.article',
    justifyContent: 'center',
    alignItems: 'stretch',
    '.profile__environments__header': {
      justifyContent: 'space-between',
      display: 'flex',
      flexDirection: 'row',
      gap: responsive({ 0: 4, 2: 0 }),
      alignItems: 'center',
      position: 'sticky',
      top: responsive({ 0: '57px', 3: '68px' }),
      pt: 3,

      backgroundColor: 'palette.background.paper',
    },
    '.notGlobal': {
      position: 'sticky',
      top: 0,
    },
    '.profile__environments__header__title': {
      overflow: 'hidden',
      textOverflow: responsive({ 0: 'ellipsis', 3: 'none' }),
      whiteSpace: responsive({ 0: 'nowrap', 3: 'unset' }),
      width: responsive({ 0: '170px', 2: 'auto' }),
    },
    '.environment__buttons': {
      display: responsive({ 0: 'contents', 1: 'flex' }),
      alignItems: 'center',
      flexDirection: 'row',
      gap: spacing(4),
    },

    '& .profileFeaturesBtn': (theme) => ({
      display: 'flex',
      padding: spacing(3),
      height: 'fit-content',
      width: 'auto',
      flexShrink: 0,
      ...theme.palette.getStatesFromPath('buttons.iconOutline'),
      '&:hover': {
        ...theme.palette.getStatesFromPath('buttons.iconPrimary'),
      },
    }),
    '&.profile__environments button': {
      // background: 'palette.gray.700',
    },
    '.removeEnvironment': {
      width: 'fit_content',
      flexShrink: 0,
    },

    '&.selected__profile__environments': {
      height: 'fit-content',
      justifyContent: 'start',
    },
    '.selected__environments__header': {
      borderBottom: '1px solid',
      borderBottomColor: 'palette.border.section',
      pb: spacing(6),
      zIndex: 'stickyElements',
      borderRadius: 0,
    },
  },
};

export default environments;
